 <template>
  <div class="row items-stretch bg-primary-light logomaker">
    <q-btn
      icon="close"
      class="abscloseicon"
      unelevated
      color="secondary"
      round
      dense
      v-close-popup
      size="xs"
      padding="xs"
    />
    <q-file
      v-if="!imageloaded"
      filled
      label-color="white"
      bg-color="secondary"
      class="mfilepicker"
      v-model="objfile"
      label="Загрузить логотип из файла"
      max-file-size="8388608"
      dense
      bottom-slots
      accept="image/*"
      @rejected="onRejected"
    >
      <template v-slot:prepend>
        <q-icon name="cloud_upload" color="white" @click.stop />
      </template>
      <template v-slot:hint>Максимальный размер: 8 МБ</template>
    </q-file>
    <q-btn
      v-if="!imageloaded"
      unelevated
      no-caps
      align="left"
      color="secondary"
      icon="photo_size_select_large"
      class="mfindlogo"
      label="Взять логотип с сайта"
      @click="openLogoFinder"
    />
    <q-circular-progress
      v-if="loadprogress"
      indeterminate
      size="50px"
      color="secondary"
      class="q-ma-md mprogress"
    />
    <div class="logocontrols q-pa-xs" v-if="imageloaded">
      <q-list dense>
        <q-item>
          <q-item-section class="qititle">Яркость</q-item-section>
          <q-item-section>
            <q-slider
              dark
              v-model="brightness"
              :min="0"
              :max="200"
              color="accent"
              @change="setFilter"
            />
          </q-item-section>
        </q-item>

        <q-item>
          <q-item-section class="qititle">Контраст</q-item-section>
          <q-item-section>
            <q-slider
              dark
              v-model="contrast"
              :min="0"
              :max="200"
              @change="setFilter"
              color="accent"
            />
          </q-item-section>
        </q-item>
        <q-item>
          <q-item-section class="qititle">Цвет</q-item-section>
          <q-item-section>
            <q-slider
              dark
              v-model="grayscale"
              :min="0"
              :max="100"
              @change="setFilter"
              color="accent"
            />
          </q-item-section>
        </q-item>
        <q-item>
          <q-item-section class="qititle">Инверсия</q-item-section>
          <q-toggle
            size="xs"
            negative
            color="accent"
            v-model="invert"
            @input="setFilter"
          />
        </q-item>
      </q-list>
    </div>

    <cropper
      ref="logocropper"
      class="cropper col-8 q-pa-md"
      :src="img"
      @change="change"
    ></cropper>

    <div class="col-4">
      <div class="q-ml-lg bg-primary q-pa-md">
        <div class="q-mb-md">Предварительный просмотр</div>
        <q-img
          :src="preview"
          :class="preview ? 'logopreview' : 'logopreview emptylogo'"
          contain
          placeholder-src="data:image/jpeg;base64,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"
        />
        <div class="q-mt-md overflow-hidden">
          <q-btn
            style="width: 105px"
            class="q-mr-xs float-left"
            icon="close"
            unelevated
            color="primary-light"
            @click="clear"
            :disable="!preview"
          />
          <q-btn
            :loading="saving"
            unelevated
            no-caps
            icon="check"
            class="q-ml-xs float-right"
            color="secondary"
            style="width: 105px"
            @click="saveLogo"
            :disable="!preview"
          ></q-btn>
        </div>
      </div>
      <div
        v-if="rec.logo_uid"
        class="q-ml-lg q-py-md q-mt-lg currentlogo row items-center"
      >
        <div class="col-6">Текущий логотип</div>
        <div class="col-5 currentlogo_outer">
          <q-img
            :src="logopath + '/i/logo/' + rec.logo_uid"
            contain
            class="logoimage"
            placeholder-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWBAMAAADOL2zRAAAAG1BMVEXMzMyWlpaqqqq3t7fFxcW+vr6xsbGjo6OcnJyLKnDGAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABAElEQVRoge3SMW+DMBiE4YsxJqMJtHOTITPeOsLQnaodGImEUMZEkZhRUqn92f0MaTubtfeMh/QGHANEREREREREREREtIJJ0xbH299kp8l8FaGtLdTQ19HjofxZlJ0m1+eBKZcikd9PWtXC5DoDotRO04B9YOvFIXmXLy2jEbiqE6Df7DTleA5socLqvEFVxtJyrpZFWz/pHM2CVte0lS8g2eDe6prOyqPglhzROL+Xye4tmT4WvRcQ2/m81p+/rdguOi8Hc5L/8Qk4vhZzy08DduGt9eVQyP2qoTM1zi0/uf4hvBWf5c77e69Gf798y08L7j0RERERERERERH9P99ZpSVRivB/rgAAAABJRU5ErkJggg=="
          />
        </div>
        <div class="col text-right">
          <q-btn
            @click="deleteLogo"
            icon="close"
            stack
            unelevated
            text-color="white"
            size="xs"
            padding="none"
          ></q-btn>
        </div>
      </div>
    </div>
    <q-dialog v-model="logofinder" class="lfdialog">
      <LogoFinder @select-logo="logoSelected" />
    </q-dialog>
  </div>
</template>


<script>
import LogoFinder from "src/service/components/common/LogoFinder.vue";
import { Cropper } from "vue-advanced-cropper";
import { sconfig } from "src/boot/axios";
export default {
  props: {
    rec: { type: Object, default: null }
  },
  components: {
    Cropper,
    LogoFinder
  },
  data() {
    return {
      original: null,
      img: null,
      preview: null,
      objfile: null,
      loadprogress: false,
      logofinder: false,
      saving: false,
      contrast: 100,
      brightness: 100,
      grayscale: 100,
      invert: false,
      coordinates: null
    };
  },
  computed: {
    imageloaded() {
      return this.objfile != null || this.img != null;
    },
    logopath() {
      return sconfig.logopath;
    }
  },
  watch: {
    objfile: function(nv) {
      if (nv) {
        this.loadprogress = true;
        var reader = new FileReader();
        reader.onload = e => {
          this.img = e.target.result;
          if (!this.original) {
            this.original = e.target.result;
            this.brightness = 100;
            this.contrast = 100;
            this.grayscale = 100;
            this.invert = false;
          }
        };
        reader.readAsDataURL(nv);
        this.$store.commit("ADDED_LOGO_FROM_FILE");
      }
    }
  },
  methods: {
    change({ canvas }) {
      this.preview = canvas.toDataURL();
      this.loadprogress = false;
      if (this.coordinates != null) {
        this.$refs.logocropper.setCoordinates(this.coordinates);
        this.coordinates = null;
      }
    },

    setFilter() {
      let im = new Image();
      im.onload = () => {
        let canva = document.createElement("canvas");
        canva.width = im.width;
        canva.height = im.height;
        let ctx = canva.getContext("2d");

        ctx.filter =
          "brightness(" +
          this.brightness +
          "%) " +
          "contrast(" +
          this.contrast +
          "%) " +
          "invert(" +
          (this.invert ? "100" : "0") +
          "%) " +
          "grayscale(" +
          (100 - this.grayscale) +
          "%)";

        ctx.drawImage(im, 0, 0, im.width, im.height);
        this.img = canva.toDataURL();
      };
      im.src = this.original;
      this.coordinates = this.$refs.logocropper.coordinates;
    },

    clear() {
      this.objfile = null;
      this.img = null;
      this.preview = null;
      this.original = null;
      this.brightness = 100;
      this.contrast = 100;
      this.grayscale = 100;
      this.invert = false;
    },
    onRejected() {
      this.$store.commit("SET_ERROR", {
        error: true,
        errortext:
          "Размер файла слишком большой. Уменьшите размер изображения. Если вы не можете самостоятельно уменьшить изображение - напишите в техподдержку. Мы вам поможем."
      });
    },
    saveLogo() {
      this.saving = true;
      this.$store.dispatch("SAVE_LOGO", {
        action: "savelogo",
        base64: this.preview,
        rec: this.rec.Export()
      });
    },
    deleteLogo() {
      this.$store.dispatch("DELETE_LOGO", {
        action: "deletelogo",
        rec: this.rec.Export()
      });
    },
    logoSelected(sourse) {
      this.img = sourse;
      this.original = sourse;
      this.brightness = 100;
      this.contrast = 100;
      this.grayscale = 100;
      this.invert = false;
      this.logofinder = false;
      this.$store.commit("ADDED_LOGO_FROM_SITE");
    },
    openLogoFinder() {
      this.logofinder = !this.logofinder;
    }
  },
  created() {
    this.unsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type === "UPDATE_LOGO_FINISHED") {
        this.saving = false;
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
</script>

<style lang="sass">
.logomaker
  overflow: visible!important
  width: 900px
  max-width: 900px!important
  height: 500px
  max-height: 500px!important
  padding: 24px
  position: relative
.mfindlogo
  position: absolute!important
  z-index: 100
  width: 275px !important
  left: 168px
  top: 230px
.cropper
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAAAsSAAALEgHS3X78AAABVklEQVR4nO2XMYuDQBCF95dE7gcEUyum0+4RrdLmj6ZKF7TT7tSQIpiTdHfJYZqrthNXOISBecXrlmE+2Jl5z/x+tZjS0F/QlDnCJIPnR/jYbEfl+RHCJENT5hj6i7h6VobAQhokMIEJTGACb7YwQ3/BlN6PK9qqQBCnWK1DeH40qtU6RBCnaKsC78dVXD0r05Q5ptRWBc6nI3b7A4I4RZhkowriFLv9AefTEW1ViKtnZVwPpIPMrWdlXF9A+ledW8/KuIZc+jKaW8+KwFIaJDCBCTwPWN1ZUmc81FlLdeHBNeTSlxHzMIEJTGARDS4GrO4sqTMe6qyluvDgGnLpy4h5mMAEJrCIBhcDVneW1BkPddZSXXhwDbn0ZcQ8TGACE1hEg4sBqztL6oyHOmupLjy4hlz6MmIeJjCBCSyiQQL/o96zq/F9+8Szq3UAv+4Nfroar3uDP+m+hsI7MIFKAAAAAElFTkSuQmCC')
  background-color: #dcdcdc
  background-size: 5%
.logocontrols
  position: absolute
  border-radius: 5px
  font-size: 12px
  z-index: 100
  width: 170px !important
  left: 410px
  top: 35px
  background: #14192b
.logocontrols .q-slider--h
  height: 28px!important
.logocontrols .q-list--dense > .q-item
  min-height: 20px
  padding: 2px 12px 2px 6px
.logocontrols .q-list--dense > .q-item.nopl
  padding: 0px 12px 3px 0px
.logocontrols  .q-item--dense
  min-height: 20px
.mfilepicker
  position: absolute
  z-index: 100
  width: 275px !important
  left: 168px
  top: 150px
  .q-field__bottom
    color: #2b2b2b
    font-size: 14px
    font-weight: 700
.mprogress
  position: absolute !important
  z-index: 100
  width: 275px !important
  left: 158px
  top: 130px
.vue-advanced-cropper__background
  background: transparent
.logopreview.emptylogo
  height: 160px
  max-height: 160px
  border: none
.logopreview
  max-width: 100%
  max-height: 160px
  border: 1px dashed rgba(251, 251, 251,0.15)
.currentlogo_outer
  border: 1px dashed rgba(251, 251, 251,0.15)
.lfdialog
  width: 800px
  max-width: 800px!important
  height: 80%
.q-btn.abscloseicon
  position: absolute!important
  right: -10px
  top: -10px
.vue-square-handler
  background: #ef506a
.vue-simple-line
  border-color: rgb(239, 80, 106)
.qititle
  width: 30px
.lmclrbtn
  height: 20px
</style>